import { render } from "./Charts1Border.vue?vue&type=template&id=16babc3e&scoped=true"
import script from "./Charts1Border.vue?vue&type=script&lang=js"
export * from "./Charts1Border.vue?vue&type=script&lang=js"

import "./Charts1Border.vue?vue&type=style&index=0&id=16babc3e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16babc3e"]])

export default __exports__